import { useEffect, useRef, useState } from 'react';
import { useScreenshot } from 'use-react-screenshot';
export function useDownloadScreenshot(props) {
    const downloadScreenshotRef = useRef(null);
    const [downloading, setDownloading] = useState(false);
    const [, takeScreenshot] = useScreenshot({ type: props.type, quality: props.quality });
    useEffect(() => {
        if (downloading && downloadScreenshotRef.current) {
            takeScreenshot(downloadScreenshotRef.current)
                .then((file) => {
                const a = document.createElement('a');
                a.href = file;
                a.download = `${props.fileName}.${props.type ?? 'jpg'}`;
                a.click();
            })
                .catch(() => { })
                .finally(() => {
                setDownloading(false);
                props.callback?.();
            });
        }
    }, [downloading, downloadScreenshotRef, props.fileName, props.type, props.quality, takeScreenshot, props.callback]);
    function downloadScreenshot() {
        setDownloading(true);
    }
    return { downloadScreenshotRef, downloading, downloadScreenshot };
}
